export default __webpack_public_path__ + "static/media/Banner - AirDockz - Black.786a51e3.jpg";